import { motion } from "framer-motion";

export default function PageShell({ children, className = "" }) {
  return (
    <div className={`premium-site min-h-screen relative overflow-x-hidden ${className}`}>
      <div className="premium-aurora" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(37,99,235,0.08),transparent_50%)] pointer-events-none" />
      <div
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)`,
          backgroundSize: "48px 48px",
        }}
      />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="relative z-10 pt-24 lg:pt-28"
      >
        {children}
      </motion.div>
    </div>
  );
}
